import DialogPopup from "components/molecules/DialogPopup"
import { FC, useState } from "react"

import acitivity1 from 'assets/images/icon-123.png'
import { useTranslation } from "react-i18next"
import CountingDucks from "./games/CountingDucks"

const SectionActivities: FC = () => {
  const { t } = useTranslation()
  const [activity, setActivity] = useState(false)
  
  const list = [
    {
      image: acitivity1,
      color: '#fff1c2',
      title: t('dashboard.counting-ducks')
    },
  ]

  return (
      <>
        <div style={{ display: 'flex', gap: '20px' }}>
            {list.map((a, idx) => <div key={idx} style={{ width: '150px' }}>

                <div className='box-shadow'
                    onClick={() => {
                        setActivity(true)
                    }}

                    style={{
                        cursor: 'zoom-in',
                        aspectRatio: 1,
                        backgroundSize: 'auto 30px',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundColor: a.color,
                        backgroundImage: `url('${a.image}')`,
                        textAlign: 'center',
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center'
                    }}>
                      <div style={{ fontSize: '16px', fontWeight: '500', paddingBottom: '10px', textAlign: 'center' }}>{a.title}</div>
                    </div>
            </div>)}   
        </div>


         {activity &&
            <DialogPopup
                title={t('dashboard.counting-ducks')}
                open={!!activity}
                onClose={() => setActivity(null)}
                popupWidth={'1000px'}
            >
              <CountingDucks />
            </DialogPopup>
         }
    </>
  )
}

export default SectionActivities
